module.exports = __webpack_public_path__ + "static/media/hsz.94b0fb5f.mp4";